import type {
	AiManagedObjectConfig,
	AiManagedObjectConfigCreateInput,
} from '../entry-points/types';
import {
	type AiManagedObjectUpdateIntervalPreset,
	getDesiredUpdateFrequencyForInterval,
} from './update-interval';

export const toAiManagedObjectConfigInputWithUpdateInterval = (
	config: AiManagedObjectConfig,
	updateInterval?: AiManagedObjectUpdateIntervalPreset,
): AiManagedObjectConfigCreateInput => ({
	desiredUpdateFrequency: getDesiredUpdateFrequencyForInterval(updateInterval),
	goal: config.goal ?? undefined,
	goalOperations: config.goalOperations ?? undefined,
	prompt: config.prompt ?? null,
	sources:
		config.sources?.map((source) => ({
			app: source.app,
			...(source.url ? { url: source.url } : {}),
		})) ?? undefined,
});
